import { TranslateDefaultParser } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { ModuleService } from '@features/module/services/module.service';
import { Router } from '@angular/router';

@Injectable()
export class IntTranslateParser extends TranslateDefaultParser {
  constructor(public moduleService: ModuleService, private route: Router) {
    super();
  }
  // NOTE: ngx-translate v17 removed getValue() from TranslateParser.
  // Module-prefixed key lookup (e.g. "manage" prefix routing) no longer hooks here.
  // Needs reimplementation via TranslateLoader or custom TranslateService.
}
